module.exports = __webpack_public_path__ + "img/jdatec.eebedf3.png";